@if (isEditMode) {
  <div class="table-content" class="color-test padding-10 choppOff">
    <fn-color-picker [(ngModel)]="cellValue" (changeColorCb)="changeAction($event)">
    </fn-color-picker>
  </div>
}

@if (!isEditMode) {
  <div (dblclick)="dbClickAction()" class="table-content">
    <span class="fn-grid-color-box padding-10 choppOff" [ngStyle]="{ 'background-color': cellValue }">
    </span>
  </div>
}